var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRoundedUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "matrix(-1 0 0 1 9 9)",
    fill: "#DCDCE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 8.58333C11.625 8.67361 11.5925 8.75174 11.5276 8.81771L9.23071 11.151C9.16577 11.217 9.08887 11.25 9 11.25C8.91113 11.25 8.83423 11.217 8.76929 11.151L6.47241 8.81771C6.40747 8.75174 6.375 8.67361 6.375 8.58333C6.375 8.49306 6.40747 8.41493 6.47241 8.34896C6.53735 8.28299 6.61426 8.25 6.70313 8.25H11.2969C11.3857 8.25 11.4626 8.28299 11.5276 8.34896C11.5925 8.41493 11.625 8.49306 11.625 8.58333Z",
    fill: "#666687"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedUpIcon);
export default __webpack_public_path__ + "static/media/arrow_rounded_up_icon.6dad248e847c43ec8697063b20c5ce96.svg";
export { ForwardRef as ReactComponent };